export default !!(typeof window !== 'undefined' && window.document && window.document.createElement);


//////////////////
// WEBPACK FOOTER
// ./~/react-virtualized/~/dom-helpers/esm/canUseDOM.js
// module id = 1001
// module chunks = 4